"use client";

import { getTranslatedHrtName } from "@/app/directories/shop/helper";
import { useLocale } from "next-intl";
import { useProduct } from "./ProductContext";

export function ProductName({ productName }: { productName: string }) {
  const { selectedOption } = useProduct();
  const locale = useLocale();
  const languageCode = locale.replace("-", "_");

  // Validate that HRT data exists before calling the helper
  const translatedName = selectedOption?.hrt
    ? getTranslatedHrtName(selectedOption.hrt, languageCode)
    : "";

  return (
    <div className="flex flex-col gap-0">
      <div id="product-name" className="config-h3 sm:mb-4">
        {productName}
      </div>
      <div className="config-p3">{translatedName}</div>
    </div>
  );
}
